var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OperatorStore',{ref:"operatorStore"}),_c('h1',[_vm._v("Operator Page (work in progress)")]),_c('TCUsers'),_c('TCVehicles'),_c('Operators')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }